import architectureSettings from './architectureSettings'


// 定制逻辑处理
export default {
  ...architectureSettings,
}
